export default `
attribute vec2 aindex;
attribute vec3 alineposition;
attribute vec3 positionprevious;
attribute vec3 positionnext;
attribute vec2 atangentscale;
uniform float uSegmentNum;
uniform float uTime;
uniform float uLineWidth;
uniform float uScale;
uniform vec4 uRandom;

const float PI = 3.14159265359;

varying vec2 vIndex;
varying float vX;

mat3 lookAtMatrix(vec3 tangent, vec3 up){
    vec3 zaxis = -tangent;
    vec3 xaxis = normalize(cross(up, zaxis));
    vec3 yaxis = cross(zaxis, xaxis);

    return mat3(
        xaxis, yaxis, zaxis
    );
}

void main(){
  vec3 prevP = positionprevious * uScale;
  vec3 currentP = position * uScale;
  vec3 nextP = positionnext * uScale;

  vec3 dist1 = normalize(prevP - currentP);
  vec3 dist2 = normalize(currentP - nextP);

  vec3 tangent = normalize(dist1 * atangentscale.x + dist2 * atangentscale.y);

  vec3 up = vec3(0.0, 0.0, -1.0);

  vec3 pos = vec3(alineposition.x * uLineWidth, 0.0, 0.0);

  pos = lookAtMatrix(tangent, up) * pos;
  pos += currentP;

  vX = alineposition.x + 0.5;

  vIndex = aindex;

  gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(pos, 1.0);
}`
